import { Component, OnInit, TemplateRef } from '@angular/core';
import { EventVersion } from '../../core/models/event-version';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { PublishResetService } from '../../core/services/publish-reset.service';
import { UtilityService } from '../../core/services/utility.service';
import { DatePipe } from '@angular/common';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css'],
  providers:[PublishResetService]
})
export class ResetComponent implements OnInit {
  eventId:string='';
  mandatoryUpdate:boolean = false;
  prop:string='';
  isError:boolean=false;
  message:string='';
  errorMessage:string='';
  count:number=0;
  eventWebPath:string='';  
  eventAppPath:string=''; 
  desc: string=null;
  descClass = 'form-control';
  eventVersion = new EventVersion();
  propup1:boolean = false;
  propup:boolean = false;
  modalRef: BsModalRef;
  lastPublishedAt:string=null;

  RESET_LABEL1 = Constants.RESET_LABEL1;
  RESET_LABEL2 = Constants.RESET_LABEL2;
  MODAL_LABEL1 =Constants.MODAL_LABEL1;

	constructor(private confirmationService: ConfirmationService,private publishResetService:PublishResetService , private extraService:ExtraService,private route: ActivatedRoute,private router:Router,
    private utilityService:UtilityService,private modalService: BsModalService) { }

    openModal(template: TemplateRef<any>) {
      this.modalRef = this.modalService.show(template);
    }
    
	ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => { 
      let id = params['eventId']; 
      if(id) {
        this.eventId = id;
        this.setEventVersionData(id);
        this.setPublishedAt(id);
        this.extraService.setCurrentEventId(id);
      }
    });
  }

  setPublishedAt(id: string){
    this.publishResetService.getLastPublishedAt(id).subscribe(val=>{
      if(val) {
        let datePipe = new DatePipe("en-US");
        this.lastPublishedAt = datePipe.transform(val, Constants.PUBLISH_AT_DATE_FORMAT);
      }
    });
  }

  setEventVersionData(id) {
    this.count = 0;
    this.publishResetService.getEventVersionData(id).subscribe(event=>{
      if(event) {
        //console.log(event)
        this.eventVersion = event;
        this.count = event.cv;
      } 
    });
  }

  confirmReset() {
    this.modalRef.hide();
    this.propup = false;
    this.reset();
  }

  reset() {
    this.message=null;
    if(this.eventId) {
      this.setEventVersionData(this.eventId);
      this.publishResetService.getEventAppObject(this.eventId).then((snapshot)=>{
        if(snapshot) {
          this.publishResetService.copyEventAppToEventWeb(Object.assign({},snapshot.val()), this.eventId).then(res=>{
            this.message = 'Reset Successfully';
          }).catch(error=> {
              this.message = error.message;
              console.error(error);
          })
        }
      });
      setTimeout(function() {
        this.message = null;
      }.bind(this), 8000); 
    } 
  }
}



// WEBPACK FOOTER //
// /app/src/app/event/reset/reset.component.ts